// extracted by mini-css-extract-plugin
export default {"PasswordFields":"ChangePasswordForm_PasswordFields__8r6Hs","Input":"ChangePasswordForm_Input__-hQq8","ButtonContainer":"ChangePasswordForm_ButtonContainer__rrLcB"};